module.exports = __webpack_public_path__ + "img/cameras.8d89fd69.jpg";